module.exports = __webpack_public_path__ + "img/ico_xyyq.5c6aac16.png";